import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/new/home_time.png'
import _imports_1 from '@/assets/img/new/home_liveing.gif'
import _imports_2 from '@/assets/img/new/null_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-23f7e97e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_page" }
const _hoisted_2 = { class: "home_box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home_ban",
  src: "https://yx-vocational.oss-cn-shenzhen.aliyuncs.com/images/home_ban.png",
  alt: ""
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "home_list"
}
const _hoisted_5 = { class: "home_scroll" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "item_title" }
const _hoisted_8 = { class: "title_left" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "main_scroll" }
const _hoisted_12 = {
  key: 0,
  class: "curriculumDiv"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "video_img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 2,
  class: "video_update"
}
const _hoisted_18 = {
  key: 3,
  class: "video_update"
}
const _hoisted_19 = {
  key: 0,
  class: "video_status"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "video_status"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_23 = {
  key: 2,
  class: "video_status"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "video_title" }
const _hoisted_26 = { class: "tit_name" }
const _hoisted_27 = { class: "video_name" }
const _hoisted_28 = { class: "video_span" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "null_box"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]

import { onMounted, reactive, toRaw, toRefs } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex';
import dataInit from '../recorded_broadcast/hooks/record_menu' // 混入录播菜单栏
import dataLive from '../live_broadcast/hooks/live_menu' // 混入录播菜单栏
import bus from '@/utils/bus';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { isShow, GetUserCurriculum } = dataInit()
const { GetLiveCurriculum } = dataLive()

// 初始化
let person: any = reactive({
    typeList:[
        {
            name:'录播课程',
            img: require('@/assets/img/new/home_record.png'),
            data: {
                list: [],
                PageIndex: 1,
                PageSize: 8,
                total: 0
            }
        },
        {
            name: '直播课程',
            img: require('@/assets/img/new/home_live.png'),
            data: {
                list: [],
                PageIndex: 1,
                PageSize: 8,
                total: 0
            }
        },
        {
            name: '录播免费课',
            img: require('@/assets/img/new/home_open.png'),
            data: {
                list: [],
                PageIndex: 1,
                PageSize: 8,
                total: 0
            }
        },
        {
            name: '直播免费课',
            img: require('@/assets/img/new/home_live_open.png'),
            data: {
                list: [],
                PageIndex: 1,
                PageSize: 8,
                total: 0
            }
        }
    ],
    imgs: [require('@/assets/img/new/course_1.png'), require('@/assets/img/new/course_2.png'), require('@/assets/img/new/course_3.png')]
})
const router=useRouter()
const store = useStore()
onMounted(() => {
    // 判断是主页，头部不加背景色
    if (router.currentRoute.value.name === 'teaIndex') {
        store.commit('setIsBg', false)
    }
    scroll()
    getMenu()
})
const scroll=()=>{
    let homeBox=document.getElementsByClassName('home_box')[0]
    homeBox.onscroll = () => {
        // 滚动到300时，改变头部颜色
        if (homeBox.scrollTop>=100){
            if (router.currentRoute.value.name === 'teaIndex') {
                store.commit('setIsBg', true)
            }
        }else{
            if (router.currentRoute.value.name === 'teaIndex') {
                store.commit('setIsBg', false)
            }
        }
    }
}

const getMenu = ()=>{
    person.typeList&&person.typeList.forEach((ty:any)=>{
        if (ty.name === '录播课程'){
            GetUserCurriculum(ty.data, 1)
        } else if (ty.name === '录播免费课'){
            GetUserCurriculum(ty.data, 2)
        } else if (ty.name === '直播课程') {
            GetLiveCurriculum(ty.data, 1)
        } else if (ty.name === '直播免费课') {
            GetLiveCurriculum(ty.data, 2)
        }
    })
}
// 录播详情
let toStudy = (item: any, name: string) => {
    if (item.PlayStatus){ // 直播
        let obj = { NodeId: item.Id, Id: item.Id, IsCollect: -1 }
        localStorage.setItem('setId', JSON.stringify(obj))
        router.push({ name: 'liveDetails' })
    }else{ // 录播
        let obj = { NodeId: item.Id, Id: item.Id, IsCollect: -1 }
        localStorage.setItem('setId', JSON.stringify(obj))
        // 下载权限
        if(name === '录播课程'){
          let obj1 = { isOpenClass:false }
          localStorage.setItem('openClass', JSON.stringify(obj1))
        }else{ // 允许下载
          let obj1 = { isOpenClass:true }
          localStorage.setItem('openClass', JSON.stringify(obj1))
        }
        router.push({ name: 'recordDetails' })
    }
}
// 查看更多
const toMore=(name:string)=>{
    if (name==='录播课程'){
        let obj = { Id: 0, AliasName: name, listType: 1, PageType:1,IsHome:1 }
        localStorage.setItem('listType', JSON.stringify(obj))
        router.push({ name: 'recordedBroadcast' })
    } else if (name ==='录播免费课'){
        let obj = { Id: 0, AliasName: name, listType: 2, PageType: 2, IsHome: 1 }
        localStorage.setItem('listType', JSON.stringify(obj))
        router.push({ name: 'recordedBroadcast' })
    } else if (name === '直播课程') {
        let obj = { Id: 0, AliasName: name, listType: 1, PageType: 3, IsHome: 1 }
        localStorage.setItem('listType1', JSON.stringify(obj))
        router.push({ name: 'liveBroadcast' })
    } else if (name === '直播免费课') {
        let obj = { Id: 0, AliasName: name, listType: 2, PageType: 4, IsHome: 1 }
        localStorage.setItem('listType1', JSON.stringify(obj))
        router.push({ name: 'liveBroadcast' })
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_unref(person).typeList && _unref(person).typeList.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(person).typeList, (type, typeIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "home_item",
                  key: typeIndex
                }, [
                  (type.data.list && type.data.list.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("img", {
                              src: type.img,
                              alt: ""
                            }, null, 8, _hoisted_9),
                            _createElementVNode("span", null, _toDisplayString(type.name), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "title_more",
                            onClick: ($event: any) => (toMore(type.name))
                          }, "查看更多 >", 8, _hoisted_10)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          (type.data.list && type.data.list.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.data.list, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "main_item",
                                    key: index,
                                    onClick: ($event: any) => (_unref(toStudy)(item, type.name))
                                  }, [
                                    _createElementVNode("div", _hoisted_14, [
                                      (item.CoverUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: item.CoverUrl,
                                            alt: ""
                                          }, null, 8, _hoisted_15))
                                        : (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            src: _unref(person).imgs[Math.floor(Math.random() * (_unref(person).imgs.length))],
                                            alt: ""
                                          }, null, 8, _hoisted_16)),
                                      (!item.PlayStatus)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, "更新日期: " + _toDisplayString(item.UpdateTime), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            (item.PlayStatus === 1 && item.IsDayPlay===1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                  _hoisted_20,
                                                  _createTextVNode("今日直播 " + _toDisplayString(item.BeginTime), 1)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (item.PlayStatus === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                  _hoisted_22,
                                                  _createTextVNode("直播中")
                                                ]))
                                              : _createCommentVNode("", true),
                                            (item.IsDayPlay === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                  _hoisted_24,
                                                  _createTextVNode("下一场直播 " + _toDisplayString(item.BeginTime), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("p", _hoisted_26, _toDisplayString(item.Name), 1),
                                      _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, " 课时:" + _toDisplayString(item.ClassHour) + "节 ", 1),
                                        (item.TeacherName)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, "主讲:" + _toDisplayString(item.TeacherName), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ], 8, _hoisted_13))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_33))
    ])
  ]))
}
}

})